import axios from "axios";
import LocalStorage, { getToken } from "../helpers/localStorage";

const API_URL = `${process.env.REACT_APP_BASE_API_URL}/api`;

class Axios {
  constructor(baseURL) {
    this.axios = axios.create({
      baseURL,
    });

    this.axios.interceptors.request.use(this._requestMiddleware);

    this.axios.interceptors.response.use(
      this._responseMiddleware,
      this._responseErr
    );
  }

  _requestMiddleware = (req) => {
    // Send Bearer token on every request
    const token = getToken();
    if (!!token) req.headers.Authorization = token;
    return req;
  };

  _responseMiddleware = (response) => {
    //  Do something on every success full response
    return response;
  };

  _responseErr = (error) => {
    // Requests can opt out (e.g. logout, where a 401 just means the token is already dead)
    if (error?.response?.status === 401 && !error?.config?.skipAuthRedirect) {
      //   Logout / Redirect
      //   EX:
      LocalStorage.clean();
      //   store.dispatch(logout());
      window.location.reload();
      return Promise.reject(error);
    }
    return Promise.reject(error);
  };
}

const axiosApiFullyRaw = new Axios(API_URL).axios;

export { axiosApiFullyRaw };
